import { render, staticRenderFns } from "./BloqueadorCodigos.vue?vue&type=template&id=04f1af34&scoped=true"
import script from "./BloqueadorCodigos.vue?vue&type=script&lang=js"
export * from "./BloqueadorCodigos.vue?vue&type=script&lang=js"
import style0 from "./BloqueadorCodigos.vue?vue&type=style&index=0&id=04f1af34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1af34",
  null
  
)

export default component.exports